import { Component, OnInit } from '@angular/core';
import {Usuario} from '../model/usuario';
import {UsuarioService} from '../services/usuarioService';
import { AppConfigService } from '../app.config';
import { MyHttpService } from '../services/MyHttpService';
import { Observable } from "rxjs";
import { Response } from '@angular/http';

//Esto irá en Login
class EnvLogin {
  created: string;
  id: string;
  ttl: string;
  userId: string;
}

@Component({
  selector: 'app-adminlanding',
  templateUrl: './adminlanding.component.html',
  styleUrls: ['./adminlanding.component.scss']
})
export class AdminlandingComponent implements OnInit {

  usuarios: Usuario[];
  token: string;//Esto irá en el usuario que está conectado

  constructor(private usuariosService: UsuarioService,
  private configAngular: AppConfigService,
  private httpservice: MyHttpService
) { }

  ngOnInit() {
    this.loginUserLoopBack();
  }


/**
Esto es una chapucilla. En realidad cuando el usuario haga el login hay que hacer
el login en LoopBack, lo pongo aquí para salir del paso mientras se cambia el login,
que hay que definir si se hace por roles.
*/
  loginUserLoopBack(){
    console.log("****** loginUserLoopBack ******");
    this.httpservice.loginUserLoopBack(this.configAngular.getUsersUrl())
          .map((res: Response) => {
              res.json();
              //console.log(res.json().id);
              //almacenamos el token del login del usuario para loopback
              this.token = res.json().id;

            }
          ).catch((error: any):any => {
              console.log(error);
              //resolve(true);
              return Observable.throw(error.json().error || 'Server error');
          })
           //.subscribe(response: Response) => { // on sucesss
           .subscribe( (envResponse: EnvLogin) => {
             console.log(envResponse);
             //Una vez logueados recuperamos los usuarios
             this.getUsuarios();

           },
           (err: any) => { // on error
             console.log(err);
             //this.loading.next(false);
           },
           () => { // on completion

           }
         );
  }


  getUsuarios(){
  this.usuariosService.getUsuarios(this.configAngular.getUsuariosUrl(),
        this.token).subscribe(
         (usuarios: Usuario[]) => { // on sucesss

           this.usuarios = usuarios;
         },
         (err: any) => { // on error
           console.log(err);
           //this.loading.next(false);
         },
         () => { // on completion

         }
       );
}

}



// WEBPACK FOOTER //
// ./src/app/adminlanding/adminlanding.component.ts